import React from "react";
import { withRouter } from "react-router-dom";
import UnitTrustRegisterComponent from "./UnitTrustRegisterComponent";

const UnitTrustRegisterLanding = () => {
  return <UnitTrustRegisterComponent />
};
export default withRouter(UnitTrustRegisterLanding);